import {
  Component,
  computed,
  DestroyRef,
  effect,
  ElementRef,
  inject,
  signal,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ClientProcessingService } from '@services/client-processing.service';

@Component({
  selector: 'app-sync-processing-overlay',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './sync-processing-overlay.component.html',
  styleUrl: './sync-processing-overlay.component.scss',
})
export class SyncProcessingOverlayComponent {
  protected clientProcessingService = inject(ClientProcessingService);
  private host = inject<ElementRef<HTMLElement>>(ElementRef);
  private destroyRef = inject(DestroyRef);

  private renderGate = signal(true);
  protected show = computed(
    () => this.clientProcessingService.isProcessing() && this.renderGate()
  );

  private lastParent: Node | null = null;
  private healing = false;
  private observer = new MutationObserver(() => this.ensureOverlayPresent());

  constructor() {
    // On surveille tout le body uniquement pendant la synchro (aucun coût sinon).
    effect(() => {
      if (this.clientProcessingService.isProcessing()) {
        this.observer.observe(document.body, {
          childList: true,
          subtree: true,
        });
      } else {
        this.observer.disconnect();
      }
    });

    this.destroyRef.onDestroy(() => this.observer.disconnect());
  }

  private ensureOverlayPresent(): void {
    if (!this.clientProcessingService.isProcessing() || this.healing) {
      return;
    }

    const el = this.host.nativeElement;

    // Le composant entier a été retiré du DOM : sa vue Angular est intacte,
    // on ré-attache simplement son nœud (au dernier parent connu, sinon body).
    if (!el.isConnected) {
      const target =
        this.lastParent && this.lastParent.isConnected
          ? this.lastParent
          : document.body;
      target.appendChild(el);
      return;
    }

    this.lastParent = el.parentNode;

    // Seul le div interne a été retiré : on force Angular à le recréer.
    if (!el.querySelector('.processing-overlay')) {
      this.healing = true;
      this.renderGate.set(false);
      setTimeout(() => {
        this.renderGate.set(true);
        this.healing = false;
      });
    }
  }
}
